import { render } from "./bell_notifications.vue?vue&type=template&id=42bbceb6&scoped=true"
import script from "./bell_notifications.vue?vue&type=script&lang=js"
export * from "./bell_notifications.vue?vue&type=script&lang=js"

import "./bell_notifications.vue?vue&type=style&index=0&id=42bbceb6&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bbceb6"]])

export default __exports__